import { useSet } from 'ahooks';
import { Button, Checkbox, Col, Divider, Input, List, message, Radio, Row, Tabs, Tooltip, Upload } from 'antd';
import React, { useState } from 'react';
import { ontologyBrushData } from '../../../../../src/api/inspiration';
import './index.less';

const { TabPane } = Tabs;

export default () => {

    const [originClassify, setOriginClassify] = useState('') //源数据筛选条件-分类
    const [originAttr, setOriginAttr] = useState('') // 源数据筛选条件-属性
    const [set, { add, remove, reset }] = useSet([]); // 图片id集合
    const [collIdText, setCollIdText] = useState('')// 图集id

    const [classifyRadioValue, setClassifyRadioValue] = useState(1)
    const [targetClassify, setTargetClassify] = useState('') // 原分类修改的目标分类
    const [newAttr, setNewAttr] = useState('') // 需要添加的新属性
    const [oldAttr, setOldAttr] = useState('') // 需要修改的旧属性
    const [targetAttr, setTargetAttr] = useState('') // 旧属性修改的目标属性
    const [deleteAttr, setDeleteAttr] = useState('') // 删除属性
    const [maintainExistAttr, setMaintainExistAttr] = useState(true) // 根据其他信息打属性和补充标签 0否1是

    const [newSupplement, setNewSupplement] = useState('') // 需要添加的补充标签
    const [oldSupplement, setOldSupplement] = useState('') // 需要修改的旧补充标签
    const [targetSupplement, setTargetSupplement] = useState('') // 旧补充标签修改的目标补充标签
    const [deleteSupplement, setDeleteSupplement] = useState('') // 需要删除的补充标签
    const [originClassifyToSupplement, setOriginClassifyToSupplement] = useState(false) // 图片原分类是否打成补充标签 0否 1是

    const [deleteOriginClassify, setDeleteOriginClassify] = useState(1) // 是否批量删除 0-不删 1-删

    const [loading, setLoading] = useState(false)

    const getUsername = () => {
        return localStorage.getItem('username');
    };

    const handleSubmit = () => {
        let collIdList = []
        if (collIdText != "") {
            let arr = collIdText.split(",")
            collIdList = arr.map(Number)
        }
        let params = {
            originClassify: originClassify, //源数据筛选条件-分类
            originAttr: originAttr, //源数据筛选条件-属性
            insIdList: Array.from(set), // 图片id集合
            collIdList: collIdList, // 图集id
        }

        if (deleteOriginClassify == 1) {
            if (classifyRadioValue == 0) {
                // 修改分类
                params.targetClassify = targetClassify //原分类修改的目标分类
            }
            params = {
                ...params,
                deleteOriginClassify: 0,
                newAttr: newAttr,
                oldAttr: oldAttr, // 需要修改的旧属性
                targetAttr: targetAttr, //旧属性修改的目标属性
                deleteAttr: deleteAttr, // 删除属性
                addAttrAndSupplementByText: maintainExistAttr ? 1 : 0,// 默认继承修改前的属性 0否1是
                newSupplement: newSupplement, //需要添加的补充标签
                oldSupplement: oldSupplement, //需要修改的旧补充标签
                targetSupplement: targetSupplement, //旧补充标签修改的目标补充标签
                deleteSupplement: deleteSupplement,// 需要删除的补充标签
                originClassifyToSupplement: originClassifyToSupplement ? 1 : 0, //图片原分类是否打成补充标签 0否 1是
            }
        } else {
            params.deleteOriginClassify = 1
        }
        setLoading(true)
        ontologyBrushData(params, getUsername()).then(res => {
            if (res.error.code == 0) {
                message.success('提交成功')
            } else {
                message.error(res.data)
            }
        }).finally(() => {
            setLoading(false)
        })
    }

    const handleClassifyRadioChange = (e) => {
        setClassifyRadioValue(e.target.value)
    }

    const data = ['源数据筛选条件是指你要处理的内容的范围',
        '数据处理规则是指你要对图片做的修改动作',
        '场景一：',
    ]


    function callback(key) {
        setDeleteOriginClassify(key)
    }

    /**
     * 重置输入框
     */
    const resetData = () => {
        setOriginClassify('')
        setOriginAttr('')
        reset()
        setCollIdText('')
        setClassifyRadioValue(1)
        setTargetClassify()
        setNewAttr()
        setOldAttr()
        setTargetAttr()
        setDeleteAttr()
        setMaintainExistAttr(true)
        setNewSupplement('')
        setOldSupplement('')
        setTargetSupplement('')
        setDeleteSupplement('')
        setOriginClassifyToSupplement(false)
        setDeleteOriginClassify(1)
    }

    return (<div>
        <List
            header={<div>使用说明</div>}
            bordered
            dataSource={data}
            renderItem={item => (
                <List.Item>
                    {item}
                </List.Item>
            )}
        />
        <Button onClick={resetData}>重置</Button>
        <Divider>源数据筛选条件</Divider>
        <Row gutter={24}>
            <Col span={6}>
                分类：
                <Input placeholder="分类" value={originClassify} onChange={(e) => setOriginClassify(e.target.value)} />
            </Col>
            <Col span={6}>
                属性：
                <Input placeholder="属性" value={originAttr} onChange={(e) => setOriginAttr(e.target.value)} />
            </Col>
            <Col span={6}>
                图片文件夹：
                <Upload action="" showUploadList={false} customRequest={() => { }} beforeUpload={(file, fileList) => {
                    const filename = file.name
                    add(Number(filename.split('.')[0]))
                    return false
                }} directory>
                    <Button>选择文件夹</Button>
                </Upload>
                <div><Tooltip title={() => {
                    let text = ''
                    if (set.size) {
                        set.forEach(item => {
                            text += item + ','
                        })
                    }
                    return text
                }}>已读取{set.size}张图片(鼠标移入可查看id列表)</Tooltip></div>
                <button onClick={reset}>清空</button>
            </Col>
            <Col span={6}>
                图集ID:
                <Input placeholder="图集id" value={collIdText} onChange={(e) => setCollIdText(e.target.value)} />
            </Col>
        </Row>
        <Divider>数据处理规则</Divider>

        <Tabs defaultActiveKey="1" onChange={callback}>
            <TabPane tab="批量修改" key="1">
                <Divider orientation='left'>分类</Divider>
                <Row gutter={24}>
                    <Radio.Group onChange={handleClassifyRadioChange} value={classifyRadioValue}>
                        <Col>
                            <Radio value={0}>把原分类修改为&nbsp;<Input style={{ width: 150 }} value={targetClassify} onChange={(e) => setTargetClassify(e.target.value)} />&nbsp;分类</Radio>
                        </Col>
                        <Col>
                            <Radio value={1}>继承修改前的分类</Radio>
                        </Col>
                    </Radio.Group>
                </Row>
                <Divider orientation='left'>属性</Divider>
                <Row gutter={24}>
                    <Col span={6}>
                        添加新的属性：<Input style={{ width: 150 }} value={newAttr} onChange={(e) => setNewAttr(e.target.value)} />
                    </Col>
                    <Col span={10}>
                        把&nbsp;<Input style={{ width: 150 }} value={oldAttr} onChange={(e) => setOldAttr(e.target.value)} />&nbsp;属性修改为&nbsp;<Input style={{ width: 150 }} value={targetAttr} onChange={(e) => setTargetAttr(e.target.value)} />&nbsp;属性
                    </Col>
                    <Col span={4}>
                        删除&nbsp;<Input style={{ width: 150 }} value={deleteAttr} onChange={(e) => setDeleteAttr(e.target.value)} />&nbsp;属性
                    </Col>
                    <Col span={4}>
                        <Checkbox checked={maintainExistAttr} onChange={(e) => setMaintainExistAttr(e.target.checked)}>根据其他信息打属性和补充标签</Checkbox>
                    </Col>
                </Row>
                <Divider orientation='left'>补充标签</Divider>
                <Row gutter={24}>
                    <Col span={6}>
                        添加新的标签：<Input style={{ width: 150 }} value={newSupplement} onChange={e => setNewSupplement(e.target.value)} />
                    </Col>
                    <Col span={10}>
                        把&nbsp;
                        <Input style={{ width: 150 }} value={oldSupplement} onChange={e => setOldSupplement(e.target.value)} />
                        &nbsp;标签修改为&nbsp;
                        <Input style={{ width: 150 }} value={targetSupplement} onChange={e => setTargetSupplement(e.target.value)} />&nbsp;标签
                    </Col>
                    <Col span={4}>
                        删除&nbsp;<Input style={{ width: 150 }} value={deleteSupplement} onChange={e => setDeleteSupplement(e.target.value)} />&nbsp;标签
                    </Col>
                    <Col span={4}>
                        <Checkbox checked={originClassifyToSupplement} onChange={(e) => setOriginClassifyToSupplement(e.target.checked)}>将原分类打上补充标签</Checkbox>
                    </Col>
                </Row>
                <Row gutter={24}>
                    <Col span={24}>
                        <Button onClick={handleSubmit} loading={loading} style={{ float: 'right', marginTop: 20 }} type="primary">
                            点击开始处理
                        </Button>
                    </Col>
                </Row>

            </TabPane>
            <TabPane tab="批量删除" key="2">
                <Button onClick={handleSubmit} loading={loading} style={{ marginTop: 20 }} type="primary">
                    点击开始处理
                </Button>
            </TabPane>
        </Tabs>


    </div>
    )
}